import { render, staticRenderFns } from "./conversation-page.vue?vue&type=template&id=5978093e&scoped=true&"
import script from "./conversation-page.vue?vue&type=script&lang=js&"
export * from "./conversation-page.vue?vue&type=script&lang=js&"
import style0 from "./conversation-page.vue?vue&type=style&index=0&id=5978093e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978093e",
  null
  
)

export default component.exports